import React, { useState } from "react"
import DateRangePresets from "../DateRangePresets"

const TXN_TYPES = [
  "AppSubscriptionSale",
  "AppUsageSale",
  "AppSubscriptionSaleAdjustment",
  "AppOneTimeSale",
  "ServiceSale",
]

// App, type, shop search, and date-range filters. On mobile the panel collapses
// behind a "Filters" toggle (a drawer-lite) so the table gets the screen.
export function TransactionsFilters({ draft, setDraft, onApply, onClear, onPreset, apps, copy }) {
  const [open, setOpen] = useState(false)
  const set = (key) => (e) => setDraft({ ...draft, [key]: e.target.value })

  const field = "w-full rounded-lg border border-gray-300 dark:border-gray-700 px-3 py-2 text-sm focus:border-brand-500 focus:ring-brand-500"
  const labelCls = "block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1"

  const panel = (
    <form
      className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5"
      onSubmit={(e) => {
        e.preventDefault()
        onApply()
        setOpen(false)
      }}
    >
      <div>
        <label className={labelCls}>{copy.filters.type}</label>
        <select className={field} value={draft.type || ""} onChange={set("type")}>
          <option value="">{copy.filters.all}</option>
          {TXN_TYPES.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={labelCls}>{copy.filters.app}</label>
        <select className={field} value={draft.app_id || ""} onChange={set("app_id")}>
          <option value="">{copy.filters.all}</option>
          {apps.map((a) => (
            <option key={a.id} value={a.id}>{a.name}</option>
          ))}
        </select>
      </div>
      <div>
        <label className={labelCls}>{copy.filters.shop}</label>
        <input
          className={field}
          type="text"
          value={draft.shop_domain || ""}
          onChange={set("shop_domain")}
          placeholder={copy.filters.shopPlaceholder}
        />
      </div>
      <div>
        <label className={labelCls}>{copy.filters.from}</label>
        <input className={field} type="date" value={draft.from || ""} onChange={set("from")} />
      </div>
      <div>
        <label className={labelCls}>{copy.filters.to}</label>
        <input className={field} type="date" value={draft.to || ""} onChange={set("to")} />
      </div>
      <div className="flex items-end gap-2 sm:col-span-2 lg:col-span-5">
        <button
          type="submit"
          className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-medium text-white hover:bg-brand-700"
        >
          {copy.filters.apply}
        </button>
        <button
          type="button"
          onClick={() => {
            onClear()
            setOpen(false)
          }}
          className="rounded-lg border border-gray-300 dark:border-gray-700 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
        >
          {copy.filters.clear}
        </button>
      </div>
    </form>
  )

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <div className="mb-3 flex items-center justify-between sm:hidden">
        <span className="text-sm font-semibold text-gray-900 dark:text-gray-100">{copy.filters.heading}</span>
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="rounded-lg border border-gray-300 dark:border-gray-700 px-3 py-1.5 text-sm font-medium text-gray-700 dark:text-gray-300"
        >
          {open ? copy.filters.close : copy.filters.open}
        </button>
      </div>
      <div className={open ? "block" : "hidden sm:block"}>
        {onPreset && (
          <div className="mb-3">
            <DateRangePresets onSelect={onPreset} labels={copy.filters.presets} />
          </div>
        )}
        {panel}
      </div>
    </div>
  )
}
